import {
  RULE_ERROR_MESSAGE_KEY,
  RULE_RESULT_VALUE_KEY,
  type RuleContentType,
  type RuleResultSchema,
  type RuleResultValue,
} from './rules'
import { isEmptyRuleValue } from './rule-utils'

export type RuleDraftValidationKey =
  | 'ruleNameRequired'
  | 'errorMessageRequired'
  | 'resultValueRequired'

export interface RuleDraftValidationInput {
  ruleName: string
  content: RuleContentType
  resultJson: RuleResultValue
  ruleResult?: RuleResultSchema
}

export function validateRuleDraft(
  input: RuleDraftValidationInput
): RuleDraftValidationKey | null {
  if (!input.ruleName.trim()) {
    return 'ruleNameRequired'
  }

  if (input.content === 'error') {
    const message = input.resultJson[RULE_ERROR_MESSAGE_KEY]
    if (
      isEmptyRuleValue(message) ||
      (typeof message === 'string' && !message.trim())
    ) {
      return 'errorMessageRequired'
    }
  }

  if (input.content === 'result') {
    const value = input.resultJson[RULE_RESULT_VALUE_KEY]
    const resultType = input.ruleResult?.type

    if (resultType === 'switch') {
      if (value !== true && value !== false) {
        return 'resultValueRequired'
      }
      return null
    }

    if (resultType === 'number') {
      if (value === null || value === undefined || value === '') {
        return 'resultValueRequired'
      }
      return null
    }

    if (isEmptyRuleValue(value)) {
      return 'resultValueRequired'
    }
  }

  return null
}
